import { isCollection } from 'immutable';
import { OnboardingData } from 'registration/types';

export const ensureDesiredLocationsArray = (
  desiredLocations: OnboardingData['desiredLocations']
) => {
  if (Array.isArray(desiredLocations)) {
    return desiredLocations;
  }

  if (isCollection(desiredLocations)) {
    return desiredLocations.toArray();
  }

  return [];
};

export const ensureDesiredLocationsTagCompatible = (
  desiredLocations: OnboardingData['desiredLocations']
) => {
  if (Array.isArray(desiredLocations)) {
    return desiredLocations;
  }

  return [];
};

export const isDesiredLocationsListOfPlaces = (
  desiredLocations: OnboardingData['desiredLocations']
) => isCollection(desiredLocations);
